/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RouteTemplatesConstraintDtoModel, RouteTemplatesConstraintDtoModelType } from "./RouteTemplatesConstraintDtoModel"
import { RouteTemplatesConstraintDtoModelSelector } from "./RouteTemplatesConstraintDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  constraints: RouteTemplatesConstraintDtoModelType;
}

/**
 * RouteTemplatesDtoBase
 * auto generated base class for the model RouteTemplatesDtoModel.
 */
export const RouteTemplatesDtoModelBase = withTypedRefs<Refs>()(ModelBase
  .named('RouteTemplatesDto')
  .props({
    __typename: types.optional(types.literal("RouteTemplatesDto"), "RouteTemplatesDto"),
    id: types.identifier,
    uuid: types.union(types.undefined, types.string),
    name: types.union(types.undefined, types.string),
    transportationMode: types.union(types.undefined, types.null, types.string),
    constraints: types.union(types.undefined, MSTGQLRef(types.late((): any => RouteTemplatesConstraintDtoModel))),
    active: types.union(types.undefined, types.boolean),
    routeLimit: types.union(types.undefined, types.null, types.integer),
    projectId: types.union(types.undefined, types.integer),
    createdOn: types.union(types.undefined, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class RouteTemplatesDtoModelSelector extends QueryBuilder {
  get id() { return this.__attr(`id`) }
  get uuid() { return this.__attr(`uuid`) }
  get name() { return this.__attr(`name`) }
  get transportationMode() { return this.__attr(`transportationMode`) }
  get active() { return this.__attr(`active`) }
  get routeLimit() { return this.__attr(`routeLimit`) }
  get projectId() { return this.__attr(`projectId`) }
  get createdOn() { return this.__attr(`createdOn`) }
  constraints(builder: string | RouteTemplatesConstraintDtoModelSelector | ((selector: RouteTemplatesConstraintDtoModelSelector) => RouteTemplatesConstraintDtoModelSelector) | undefined) { return this.__child(`constraints`, RouteTemplatesConstraintDtoModelSelector, builder) }
}
export function selectFromRouteTemplatesDto() {
  return new RouteTemplatesDtoModelSelector()
}

export const routeTemplatesDtoModelPrimitives = selectFromRouteTemplatesDto().uuid.name.transportationMode.active.routeLimit.projectId.createdOn
